import debounce from "lodash.debounce";
import { trackEvent } from "services/bigbrain-service";
import { BACKGROUND_IMAGE_CARD_HOVERED } from "constants/bigbrain-event-types";
import BackgroundImageCard from "./background-image-card/background-image-card";
import { StyledBackgroundImageCardsGridComponent } from "./background-image-cards-grid-component.scss";

const DEBOUNCE_HOVER_TIME = 1000;

const BackgroundImageCardsGridComponent = ({ cards, cardHeight, fullParagraphAdvancedConfig, cardsGap }) => {
  const onHover = debounce((index) => {
    trackEvent(BACKGROUND_IMAGE_CARD_HOVERED, { info1: index });
  }, DEBOUNCE_HOVER_TIME);

  return (
    <StyledBackgroundImageCardsGridComponent cardsGap={cardsGap} className="background-image-cards-grid-component">
      {cards?.map((card, index) => (
        <BackgroundImageCard
          key={index}
          onHover={() => onHover(index)}
          fullParagraphAdvancedConfig={fullParagraphAdvancedConfig}
          cardHeight={cardHeight}
          {...card}
        />
      ))}
    </StyledBackgroundImageCardsGridComponent>
  );
};

export default BackgroundImageCardsGridComponent;
